// eslint-disable-next-line import/prefer-default-export
export { format32bitFloat };

/* FRONTEND_START_MARKER */

function format32bitFloat(value) {
    if (Number(value) % 1 !== 0) {
        value = Math.fround(Number(value));
        // now using shortest representation
        return value.toString().replace(/\.?0+$/, '');
    }
    return value;
}
